import { z } from "zod";
import { success } from "@secretaa/http-contract";
import { Result as RootResult } from "./ai-preparation-reply.ts";
import { Result as ChildResult } from "./ai-preparation-child-reply.ts";
import { Scope,Profile } from "./ai-model-control.ts";
export const Result=z.union([RootResult,ChildResult]);
export type Result=z.infer<typeof Result>;
export const Response=success(Result);
/** Wakeup carries identifiers only; Data remains authority for instructions, context and funding. */
export const Command=z.object({scope:Scope,profile:Profile}).strict();
export type Command=z.infer<typeof Command>;
export const PATH="/internal/v1/ai/preparations/run";
export const CONTRACT_VERSION="1.1.0";
